// Saved API responses use inches and pounds, just like the provider adapter.
// Keep absent goal fields absent so they fall back to the current body.
export const bodyDataFromMeasurements = (current = {}, goal = {}) => ({
    ...current.user,
    ...current.measures,
    bodyFat: current.bodyFat,
    bodyRank: current.metrics?.bodyRank?.value,
    goals: Object.fromEntries(Object.entries({
        ...goal.goalMeasures,
        weight: goal.user?.goalWeight,
        bodyFat: goal.bodyFat,
        bodyRank: goal.metrics?.bodyRank?.value,
    }).filter(([, value]) => value != null)),
});

// Input is newest first. Keep both endpoints and fit four distinct check-ins
// to evenly spaced dates, minimizing total squared distance from those dates.
export const spreadBodyCheckIns = snapshots => {
  if (snapshots.length <= 6) return snapshots;
  const dates = snapshots.map(snapshot => Date.parse(snapshot.date));
  const newest = dates[0];
  const oldest = dates[dates.length - 1];
  let previous = [{ cost: 0, indices: [] }];
  for (let slot = 1; slot <= 4; slot += 1) {
    const target = newest + (oldest - newest) * slot / 5;
    const next = [];
    let best = null;
    for (let index = 1; index < dates.length - 1; index += 1) {
      const candidate = previous[index - 1];
      if (candidate && (!best || candidate.cost < best.cost)) best = candidate;
      if (best) next[index] = {
        cost: best.cost + (dates[index] - target) ** 2,
        indices: [...best.indices, index],
      };
    }
    previous = next;
  }
  const best = previous.reduce((best, candidate) => !best || candidate.cost < best.cost ? candidate : best, null);
  return [snapshots[0], ...best.indices.map(index => snapshots[index]), snapshots[snapshots.length - 1]];
};
